export default {
    url : process.env.REACT_APP_BACKEND_URL,
    url_storage : process.env.REACT_APP_BACKEND_STORAGE_URL
}